import { ArchiveIcon } from '@heroicons/react/outline';
import * as React from 'react';
import './Table.scss';
type TableColumn<Entry> = {
  title: string;
  field: keyof Entry;
  width?: number;
  HeaderCell?(): React.ReactElement;
  Cell?({ entry }: { entry: Entry }): React.ReactElement;
};

export type TableProps<Entry> = {
  data?: Entry[];
  columns: TableColumn<Entry>[];
};

export const Table = <Entry extends { id?: string }>({ data, columns }: TableProps<Entry>) => {
  if (!data?.length) {
    return (
      <div className="flex flex-col items-center justify-center text-gray-500 bg-white h-80">
        <ArchiveIcon className="w-16 h-16" />
        <h4>No Entries Found</h4>
      </div>
    );
  }
  return (
    <div className="flex flex-col">
      <div className="-my-2 overflow-x-auto">
        <div className="inline-block min-w-full py-2 align-middle">
          <div className="table-outer-scroll table-wrp block">
            <table className="petsked-table min-w-full vw-full divide-y divide-gray-200">
              <thead className="sticky">
                <tr>
                  {columns.map(({ HeaderCell, title, width }, index) => (
                    <th
                      key={title + index}
                      scope="col"
                      style={{ width: `${width}%`, maxWidth: `${width}%` }}
                      className="px-6 py-3 text-lg font-medium tracking-wider text-left text-gray-500 uppercase"
                    >
                      {HeaderCell && (
                        <span className="px-2">
                          <HeaderCell />
                        </span>
                      )}
                      {title}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="max-h-96 overflow-y-auto">
                {data.map((entry, entryIndex) => (
                  <tr key={entry?.id || entryIndex} className="odd:bg-white">
                    {columns.map(({ Cell, field, title }, columnIndex) => (
                      <td
                        key={title + columnIndex}
                        className="px-6 py-4 text-lg font-medium text-gray-400 whitespace-nowrap"
                      >
                        {Cell ? <Cell entry={entry} /> : entry[field]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
